import api from '../../utils/axios';
import { partnerService } from '../partnerManagement/partnerService';

export const predefineItineraryService = {
  getItineraries: async (params = {}) => {
    const response = await api.get('/agent/itineraries', { params });
    return response.data;
  },

  getItineraryById: async (id) => {
    const response = await api.get(`/agent/itineraries/${id}`);
    return response.data;
  },

  createItinerary: async (data) => {
    const response = await api.post('/agent/itineraries', data);
    return response.data;
  },

  updateItinerary: async (id, data) => {
    const response = await api.put(`/agent/itineraries/${id}`, data);
    return response.data;
  },

  deleteItinerary: async (id) => {
    const response = await api.delete(`/agent/itineraries/${id}`);
    return response.data;
  },

  toggleStatus: async (id) => {
    const response = await api.patch(`/agent/itineraries/${id}/status`);
    return response.data;
  },

  uploadFile: async (formData) => {
    const response = await api.post('/upload/single', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  getLocations: async () => {
    return await partnerService.getLocations();
  }
};

export const itineraryService = predefineItineraryService;
export default predefineItineraryService;
